import { Grid, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { FilterProps } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    marginBottom: theme.spacing(1)
  }
}))


const InputFilter = (props: FilterProps<'input'>) => {
  const {state = {}, setState, validate, setValid} = props;
  const classes = useStyles();

  const [text, setText] = React.useState<string>(state.text || '');

  React.useEffect(() => {
    if(validate) {
      setState({text})
      setValid(true)
    }
  }, [validate]);

  return (
    <Grid
      container
      direction='column'
    >
      <Typography className={classes.text}>Enter text to search for</Typography>
      <TextField
        onChange={(e) => setText(e.target.value)}
        size='small'
        value={text}
        variant='outlined'
      />
    </Grid> 
  );
};

export default InputFilter;